// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"PointDistribution--next-sr-only--2unNaZC","filterContainer":"PointDistribution--filterContainer--3zaPUgc","filter":"PointDistribution--filter--uQFMmnd"};